<template>
  <v-page-data-table
      title="Record Query"
      key-name="id"
      :fields="fields"
      ref="record"
      :show-edit="false"
      :show-delete="false"
      query-api="RECORD_QUERY">
    <template v-slot:result="{item}">
      <v-btn text tile color="success" small v-if="item.result=='ok'">
        <v-icon small>mdi-checkbox-marked-circle</v-icon>
        成功
      </v-btn>
      <v-btn text tile color="error" small v-else-if="item.result=='repeat'">
        <v-icon color="red" small>mdi-close-circle</v-icon>
        重复扫描
      </v-btn>
      <v-btn text tile color="error" small v-else-if="item.result=='invalid'">
        <v-icon color="red" small>mdi-close-circle</v-icon>
        码不存在
      </v-btn>
    </template>
  </v-page-data-table>
</template>

<script>
import RecordQueryFields from "./fields/RecordQueryFields";

export default {
  name: "ContainerQuery",
  data() {
    return {
      fields: RecordQueryFields
    }
  }
}
</script>
